<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Variedad</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-if="variety" class="row justify-content-center">
        <card>
          <h3 slot="header" class="mb-0">Editar Variedad: {{ variety.name }}</h3>

          <variety-form :variety="variety" :show-subtitle="false" @save="saveVariety" />
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import VarietyForm from './Forms/VarietyForm';
import swal from 'sweetalert2';

export default {
  name: 'VarietiesEdit',
  components: {
    RouteBreadCrumb,
    VarietyForm,
  },

  data() {
    return {
      variety: null,
    };
  },

  created() {
    const varietyId = this.$route.params.id;
    this.fetchVariety(varietyId);
  },

  methods: {
    async fetchVariety(varietyId) {
      let params = {
        include: ['crop'],
      };

      const variety = await this.$services
        .resource('varieties')
        .show(varietyId, params)
        .then((res) => res.data.data);

      this.variety = variety;
    },

    saveVariety(variety) {
      variety.crop = variety.crop.id;
      this.$services
        .resource('varieties')
        .update(this.variety.id, variety)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'La variedad fue actualizada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'VarietiesList' }));
        });
    },
  },
};
</script>
